<template>
  <div>
    <Hero :slice="slice('hero')" />
    <LogoBanner :slice="slice('logo_banner')" />
    <Options
      :slice="slice('options')"
      :selected-option="selectedOption"
      @onSelect="onSelect"
    />
    <!-- Option Content List -->
    <transition-group name="fade">
      <OptionContent
        v-for="s in slices('option_content')"
        v-show="s.primary.index === selectedOption"
        :key="s.primary.index"
        :slice="s"
        :selected-option="selectedOption"
        :class="$style.optionContent"
      />
    </transition-group>
    <TrustpilotCarousel
      :slice="slice('trustpilot_carousel')"
      data-aos="fade-up"
    />
    <CustomerService :slice="slice('customer_service')" />
    <SimpleCta :slice="slice('simple_cta')" />
  </div>
</template>

<script>
import {
  Hero,
  LogoBanner,
  TrustpilotCarousel,
  SimpleCta,
  CustomerService,
} from '@@/shared-slices'

import { Options, OptionContent } from './components'

export default {
  name: 'LukonTerminationModule',
  components: {
    Hero,
    LogoBanner,
    Options,
    OptionContent,
    CustomerService,
    TrustpilotCarousel,
    SimpleCta,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedOption: this.slice('options').primary.initial_index || 0,
    }
  },

  methods: {
    slice(slice_type) {
      return this.data.body.find((s) => s.slice_type === slice_type)
    },
    slices(slice_type) {
      return this.data.body.filter((s) => s.slice_type === slice_type) || []
    },
    onSelect(index) {
      this.selectedOption = index
    },
  },
}
</script>

<style lang="scss" module>
.optionContent {
  @include below(small) {
    display: initial !important;
  }
}
[data-aos='fade-up'] {
  transform: translateY(50px);
  opacity: 0;

  transition-property: transform, opacity;
  &.aos-animate {
    transform: initial;
    opacity: 1;
  }
}
</style>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
</style>
